import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private get baseUrl(): string {
    return (window as any).apiUrl || (window as any).env?.apiUrl || environment.apiUrl;
  }

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    });
  }

  private handleError(error: HttpErrorResponse) {
    //console.error('Error en API service:', error);
    
    if (error.error?.error) {
      return throwError(error.error.error);
    }
    
    if (error.error) {
      return throwError({
        message: error.error.message || 'Error en la solicitud'
      });
    }
    
    return throwError({
      message: 'Ha ocurrido un error en el servidor'
    });
  }

  private formatUrl(endpoint: string): string {
    if (!endpoint) return this.baseUrl;
    if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) return endpoint;
    const base = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;
    const path = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${base}${path}`;
  }

  get<T>(endpoint: string, params?: any): Observable<T> {
    let options: any = {
      headers: this.getHeaders()
    };

    if (params) {
      if (params.filter) {
        options.params = new HttpParams().set('filter', JSON.stringify(params.filter));
      } else {
        options.params = new HttpParams({ fromObject: params });
      }
    }

    return this.http
      .get<T>(this.formatUrl(endpoint), options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http
      .post<T>(this.formatUrl(endpoint), body, {
        headers: this.getHeaders()
      })
      .pipe(catchError(this.handleError.bind(this)));
  }

  patch<T>(endpoint: string, body: any): Observable<T> {
    return this.http
      .patch<T>(this.formatUrl(endpoint), body, {
        headers: this.getHeaders()
      })
      .pipe(catchError(this.handleError.bind(this)));
  }

  delete<T>(endpoint: string, params?: any): Observable<T> {
    const httpParams = new HttpParams({ fromObject: params || {} });
    return this.http
      .delete<T>(this.formatUrl(endpoint), { 
        params: httpParams,
        headers: this.getHeaders()
      })
      .pipe(catchError(this.handleError.bind(this)));
  }
}

